import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["panel", "openIcon", "closeIcon"];

  toggle() {
    this.panelTarget.classList.toggle("hidden");
    this.panelTarget.classList.toggle("flex");
    if (this.hasOpenIconTarget) this.openIconTarget.classList.toggle("hidden");
    if (this.hasCloseIconTarget) this.closeIconTarget.classList.toggle("hidden");
  }
}
